export default {
  COLOR_POINT: "rgb(243,114,114)",
  COLOR_POINT_FILL: "rgb(255,255,255)",
  COLOR_LANDSCAPE: "#FFAD00",
  COLOR_BORDERS: "rgb(195,230,255)",
  COLOR_LINE: "#313d49",
  COLOR_SELECTED_POINT: "rgb(0,184,83)",

  DROP_OFF_MARKER: "#313d49",
  PICK_UP_MARKER: "#313d49"
};



// WEBPACK FOOTER //
// ./src/common/constants/colorPalette.js